import { render, staticRenderFns } from "./LogosGrid.vue?vue&type=template&id=80c83f60&"
import script from "./LogosGrid.vue?vue&type=script&lang=js&"
export * from "./LogosGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports